<script>
    import ExpandList from "../wrapElement/ExpandList.svelte";
</script>

<div class="rootSpace">
    <h1 class="columTitle">
        <span class="material-icons"> contact_support </span>
        <span>Pomocník</span>
    </h1>
    <div class="standartRoot">
        <ExpandList title={"Tiskárna"}>
            <div class="content">
                <p>
                    Pro správné fungování webové aplikace je potřeba, aby na
                    vašem systému byla nainstalována aplikace Browser Print.
                    Tuto aplikaci si můžete stáhnout buďto z <a
                        href="https://www.zebra.com/us/en/products/software/barcode-printers/link-os/browser-print.html"
                        target="_blank">oficiálních stránek</a
                    >, nebo tlačítkem níže.
                </p>
                <p>
                    V případě přetrvávajících problémů kontaktujte <a
                        href="mailto: support@jotio.tech">support@jotio.tech</a
                    >.
                </p>
                <button
                    on:click={() => {
                        window.open(
                            "https://www.zebra.com/content/dam/zebra_new_ia/en-us/solutions-verticals/product/Software/Printer%20Software/Link-OS/browser-print/zebra-browser-print-windows-v131445.zip",
                            "_blank"
                        );
                    }}
                    class="standartButton"
                    style="margin: 1.1rem 12px;">Stáhnout Browser Print</button
                >
                <!-- TODO -->
            </div>
        </ExpandList>
    </div>
</div>

<style>
    p {
        color: var(--back_D2);
        font-weight: 300;
        margin: 0.5rem;
    }
    .content {
        margin: 10px 0;
    }
</style>
